import { AbstractTableToolsPanel } from "../AbstractTableToolsPanel";
import { ButtonProps } from "../../../button/ButtonProps";
import { Component } from "../../../..";
import { PanelProps } from "../../../panel/PanelProps";
import { Table } from "../../Table";

export abstract class AbstractStandardTableToolsPanel extends AbstractTableToolsPanel {
    constructor(table: Table, props?: Partial<PanelProps>) {
        super(table, props);
        this.allowDropInDesigner = false;
        this.createComponents();
    }

    protected abstract createComponents(): void;
    protected abstract sync(): void;

    protected addTool(condition: boolean, tool: Component) {
        if (tool != null && condition === true) {
            this.add(tool);
            tool._designer = this.table._designer;
        }
    }

    protected get commonButtonProps(): Partial<ButtonProps> {
        return { rowBreak: false, color: "primary", imageWidth: 22, imageHeight: 22 };
    }
}
